'use client';

import { useEffect, useState } from 'react';
import s from './Preloader.module.css';

type PreloaderProps = {
  duration?: number;
  logo?: React.ReactNode;
  onDone?: () => void;
};

export default function Preloader({ duration = 1500, logo, onDone }: PreloaderProps) {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), duration);
    return () => clearTimeout(t1);
  }, [duration]);

  // cuando termina la animación de salida
  const handleAnimationEnd: React.AnimationEventHandler<HTMLDivElement> = () => {
    if (fading) {
      setVisible(false);
      onDone?.();
    }
  };

  if (!visible) return null;

  return (
    <div
      className={`${s.overlay} ${fading ? s.fadeOut : ''}`}
      onAnimationEnd={handleAnimationEnd}
      aria-live="polite"
      aria-busy={!fading}
      role="status"
    >
      <div className={s.loader}>
        <div className={s.ring} aria-hidden="true" />
        {logo ? <div className={s.logo}>{logo}</div> : null}
      </div>
    </div>
  );
}
